export default "__VITE_ASSET__GeBM2G2u__"